import { merge } from 'lodash';
import { DocuSignMachine } from '~/machines/docusign';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { DocuSign, DocuSignProps } from './docu-sign.component';

type DocuSignContainerProps = {
  micro: ContextSendMatch<DocuSignMachine>;
  overrideCopy?: DocuSignProps['overrideCopy'];
  overrideProps?: DeepPartial<DocuSignProps>;
};

export const DocuSignContainer = ({
  micro: { context, send },
  overrideCopy,
  overrideProps,
}: DocuSignContainerProps) => {
  const props: DocuSignProps = {
    childStep: 'polling',
    context: {
      useCase: context.useCase,
      user: { id: context.userId },
    },
    next: () => send({ type: 'TIMEOUT_BUTTON_CLICKED' }),
    overrideCopy,
  };

  return <DocuSign {...merge(props, overrideProps)} />;
};
